<template>
  <b-row>
    <ServerError v-if="ServerError" />
    <vue-element-loading :active="appLoading" :is-full-screen="true">
      <img src="../../assets/loader.gif" />
    </vue-element-loading>
    <b-col cols="12" lg="12">
      <b-card no-header>
        <template slot="header">
          <b-row>
            <b-col cols="6">
              <b-row>
                <b-col cols="12" md="6">
                  <span>Case Details</span>
                </b-col>
                <b-col cols="12" md="6">
                  <b-dropdown
                    variant="outline-primary"
                    size="sm"
                    id="dropdown-1"
                    :text="updateName"
                  >
                    <b-dropdown-item @click="updateReport(-1)"
                      >Initial Report</b-dropdown-item
                    >
                    <b-dropdown-item
                      v-for="(item, i) in updates"
                      :key="i"
                      @click="updateReport(i)"
                      >Update {{ i + 1 }}</b-dropdown-item
                    >
                  </b-dropdown>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="6" class="ml-auto text-right">
              <b-button
                class="mr-4"
                variant="outline-primary"
                size="sm"
                router-link
                :to="'/Discussions/' + id"
                >Discussion</b-button
              >
              <b-button
                class="mr-4"
                variant="outline-primary"
                size="sm"
                router-link
                :to="'/Similar/' + id"
                >Similar Incidents</b-button
              >
              
          
              <!-- <i  v-if="previousIcon"  class="fa fa-chevron-left pr-4" style="color:blue" @click="previous()"  aria-hidden="true"></i>
              <i v-if="nextIcon" class="fa fa-chevron-right" style="color:blue" @click="next()" aria-hidden="true"></i> -->
            </b-col>
          </b-row>
        </template>
        <div v-if="report">
          <b-row>
            <b-col cols="12" md="6">
              <b-row>
                <b-col cols="8" md="5">
                  <span class="item_title">Case ID</span>
                </b-col>
                <b-col cols="4" md="7">
                  <span v-if="report.caseidentifier" class="item_value">{{ report.caseidentifier }}</span>
                  <span v-else class="item_value">{{ report.caseid }}</span>
                </b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col cols="8" md="5">
                  <span class="item_title">Trees Being Cut</span>
                </b-col>
                <b-col cols="4" md="7">
                  <span class="item_value">{{ report.beencut }}</span>
                </b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col cols="8" md="5">
                  <span class="item_title">Trees Have Been Cut</span>
                </b-col>
                <b-col cols="4" md="7">
                  <span class="item_value">{{ report.havebeencut }}</span>
                </b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col cols="8" md="5">
                  <span class="item_title">Trees Might Be Cut</span>
                </b-col>
                <b-col cols="4" md="7">
                  <span class="item_value">{{ report.mightbecut }}</span>
                </b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col cols="12" md="5">
                  <span class="item_title">Incident Status</span>
                </b-col>
                <b-col cols="12" md="7">
                  <span class="item_value">{{ report.status }}</span>
                </b-col>
              </b-row>
              <hr />
               <b-row>
                <b-col cols="12" md="5">
                  <span class="item_title">Description</span>
                </b-col>
                <b-col cols="12" md="7">
                  <span class="item_value">{{ report.description }}</span>
                </b-col>
              </b-row>
              <hr />
            </b-col>
            <b-col cols="12" md="6">
              <b-row>
                <b-col cols="8" md="5">
                  <span class="item_title">Is Anonymous</span>
                </b-col>
                <b-col cols="4" md="7">
                  <span class="item_value">{{ report.isanonymous }}</span>
                </b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col cols="12" md="5">
                  <span class="item_title">Created Date</span>
                </b-col>
                <b-col cols="12" md="7">
                  <span class="item_value">{{
                    formatDate(report.createddate)
                  }}</span>
                </b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col cols="12" md="5">
                  <span class="item_title">Location</span>
                </b-col>
                <b-col cols="12" md="7">
                  <router-link :to="'/Map/' + report._id">
                    <span class="item_value">{{ report.locationname }}</span>
                  </router-link>
                </b-col>
              </b-row>
              <hr />
          
              <b-row>
                <b-col cols="12" md="5">
                  <span class="item_title">Cut Reason</span>
                </b-col>
                <b-col cols="12" md="7">
                  <span
                    class="item_value"
                    v-for="(item, i) in report.mightbecutreason"
                    :key="i"
                  >
                    &bull;&nbsp;{{ item }}
                    <br />
                  </span>
                </b-col>
              </b-row>
              <hr />
             
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <span class="item_title">Photos</span>
            </b-col>
            <!-- <b-col
              cols="12"
              md="4"
              v-for="(item, i) in photos"
              :key="i"
              align="center"
              class="py-2"
            >
             <img
                v-bind:src="baseURL + '/u/' + item.photo"
                v-b-modal.modal-lg
                @click="openImg(item)"
                width="auto"
                height="200px"
              />
             </b-col>
            <showImage v-if="showImg" v-bind:storage="imgModal"  @stepper="winStepper"/> -->
           <div class="card-body text-secondary">
              <div
                v-if="photos != null && photos.length > 0"
                style="
                  overflow-x: auto !important;
                  overflow-y: hidden !important;
                "
              >
                <div v-viewer style="display: flex">
                  <div
                    v-for="image in photos"
                    :key="image.key"
                    style="width: 100%; max-height: 200px"
                    class="col-md-3"
                  >
                    <img
                      :src="baseURL + '/u/' + image.photo"
                      class="image"
                      style="
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        max-width: 250px;
                      "
                      :key="image.src"
                    />
                  </div>
                </div>
              </div>
            </div>
          </b-row>
          <hr />
          <!-- Map -->
          <b-row>
            <b-col cols="12" class="py-2">
              <span class="item_title" style="font-size: 18px">Map</span>
            </b-col>
            <b-col cols="12" class="py-2">
              <locationMap v-if="report" v-bind:reportData="report" />
            </b-col>
          </b-row>
          <hr />
          <!-- User Details -->
          <b-row>
            <b-col cols="12" class="py-2">
              <span class="item_title" style="font-size: 18px">Added By</span>
            </b-col>
            <b-col v-if="user.photo" cols="12" class="py-2">
              <img :src="baseURL + '/u/' + user.photo" height="100px" />
            </b-col>
            <b-col cols="12" md="6">
              <b-row>
                <b-col cols="5">
                  <span class="item_title">Name</span>
                </b-col>
                <b-col cols="7">
                  <span class="item_value">{{ user.name }}</span>
                </b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col cols="5">
                  <span class="item_title">Phone</span>
                </b-col>
                <b-col cols="7">
                  <span class="item_value"
                    >{{ user.phonePrefix }}&nbsp;{{ user.phone }}</span
                  >
                </b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col cols="5">
                  <span class="item_title">Age</span>
                </b-col>
                <b-col cols="7">
                  <span class="item_value">{{ user.age }}</span>
                </b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col cols="5">
                  <span class="item_title">Occupation</span>
                </b-col>
                <b-col cols="7">
                  <span class="item_value">{{ user.occupation }}</span>
                </b-col>
              </b-row>
              <hr />
            </b-col>
            <b-col cols="12" md="6">
              <b-row>
                <b-col cols="5">
                  <span class="item_title">Country</span>
                </b-col>
                <b-col cols="7">
                  <span class="item_value">{{ user.country }}</span>
                </b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col cols="6" md="5">
                  <span class="item_title">Phone Verified</span>
                </b-col>
                <b-col cols="6" md="7">
                  <span class="item_value">{{ user.isPhoneVerified }}</span>
                </b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col cols="5">
                  <span class="item_title">Gender</span>
                </b-col>
                <b-col cols="7">
                  <span class="item_value">{{ user.gender }}</span>
                </b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col cols="5">
                  <span class="item_title">User ID</span>
                </b-col>
                <b-col cols="7">
                  <span class="item_value">{{ user.userid }}</span>
                </b-col>
              </b-row>
              <hr />
            </b-col>
          </b-row>
          <b-row class="justify-content-center">
            <div class="px-2">
              <b-button
                v-if="report.isinwatchlist"
                variant="outline-danger"
                @click="addToWatchlist('true')"
                size="sm"
                >Remove from Watchlist</b-button
              >
              <b-button
                v-else
                variant="outline-primary"
                @click="addToWatchlist('false')"
                size="sm"
                >Add to Watchlist</b-button
              >
            </div>
            <div class="px-2" v-if="superAdmin">
              <b-button variant="outline-danger" @click="confirmBox" size="sm"
                >Remove</b-button
              >
            </div>
          </b-row>
        </div>
        <template slot="footer">
          <b-button @click="$router.go(-1)" size="sm">Back</b-button>
        </template>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import axios from "axios";
import locationMap from "./map";
import showImage from "./ImageViewer";
export default {
  components: {
    locationMap,
    showImage
  },
  props: ["id1"],
  data() {
    return {
      fullReport: null,
      previousIcon: true,
      nextIcon: true,
      report: null,
      user: null,
      photos: [],
      appLoading: false,
      id: null,
      map: null,
      oMarker: [],
      updates: [],
      updateName: "Initial Report",
      ServerError: false,
      superAdmin: false,
      imgpopup: false,
      showImg: false,
      imgModal: {},

    };
  },
  beforeMount() {
    this.getData();
    if (localStorage.getItem("role") != "Sub Admin") this.superAdmin = true;
  },
  mounted: function () {},
  methods: {
        winStepper(window_data) {
      this.showImg=window_data.showImg
    //  this.winStep = window_data.winStep;
   },
   openImg(item) {
      this.showImg = true;
      this.imgModal = item;
      // console.log(item);
    },
    next() {
      // alert(this.id,this.idset)
      var temp = [];
      temp = this.idset.split(",");

      for (var j = 0; j < temp.length; j++) {
        if (this.id == temp[j]) {
          this.$router.push("/Cases/" + temp[j + 1] + "/" + temp);
          this.getData();
        }
      }
    },
    previous() {
      var temp = [];
      console.log("hiil", this.idset);
      temp = this.idset.split(",");

      for (var j = 0; j < temp.length; j++) {
        if (this.id == temp[j]) {
          if (j != 0) {
            this.$router.push("/Cases/" + temp[j - 1] + "/" + temp);
            this.getData();
          }
        }
      }
    },
    formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      dt = dt.toString();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime =
        day +
        " " +
        dt.slice(4, 7) +
        " " +
        year +
        " " +
        hours +
        ":" +
        minutes +
        " " +
        ampm;
      return strTime;
    },
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/incident/get",
        params: {
          id: this.$route.params.id,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.fullReport = response.data.data;
          this.report = this.fullReport;
          this.updates = this.fullReport.updates;
          this.id = this.report._id;
        //   var temp = [];
        //   temp = this.idset.split(",");
        //   if (this.id == temp[0]) {
        //     this.previousIcon = false;
        //   } else this.previousIcon = true;
        //   if (this.id == temp[temp.length - 1]) {
        //     this.nextIcon = false;
        //   }
        //   else this.nextIcon = true;
          this.user = this.report.addedby;
          this.photos = this.report.photos;
        })
        .catch((e) => {
          this.appLoading = false;
          this.ServerError = true;
        });
    },
    updateReport(item) {
      if (item == -1) {
        this.report = this.fullReport;
        this.id = this.report._id;
        this.user = this.report.addedby;
        this.photos = this.report.photos;
        this.updateName = "Initial Report";
      } else {
        this.report = this.updates[item];
        this.id = this.report._id;
        this.user = this.report.addedby;
        this.photos = this.report.photos;
        this.updateName = "Update " + (1 + item);
      }
    },
    confirmBox() {
      this.$bvModal
        .msgBoxConfirm(
          "Please confirm that you want to remove this incident. All data related to this incident will be deleted including photos, discussions etc...",
          {
            title: "Please Confirm",
            size: "md",
            buttonSize: "sm",
            okVariant: "danger",
            cancelVariant: "primary",
            okTitle: "YES",
            cancelTitle: "NO",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((value) => {
          if (value) {
            this.removeIncident();
          }
        })
        .catch((err) => {
          this.ServerError = true;
        });
    },
    addToWatchlist(item) {
      this.appLoading = true;
      var url;
      if (item == "true") {
        url = "/incident/watchlist/remove";
      } else {
        url = "/incident/watchlist/add";
      }
      axios({
        method: "POST",
        url: url,
        data: {
          id: this.$route.params.id,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.getData();
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },
    removeIncident() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/incident/remove",
        params: {
          id: this.$route.params.id,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.$router.go(-1);
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },
   
  },
};
</script>